import { useEffect, useRef, useState } from "react";
import {
	useTranslationStore,
	useTranslation,
} from "../../hooks/useTranslation";
import axios from "axios";
import { presenceService } from "@turnaroundfactor/common";
import * as sdk from "microsoft-cognitiveservices-speech-sdk";
import { languages } from "../../data/languages";
import TranslatorCompanion from "./Companion";
import { useSettings } from "@turnaroundfactor/react";
import TranslationItem from "./Translation";

export default function Translation() {
	const setConfig = useTranslationStore((store) => store.setConfig);
	const creds = useRef(null);
	const timer = useRef(null);

	const messages = useTranslationStore((store) => store.messages);
	const [list, setList] = useState([]);

	// eslint-disable-next-line no-unused-vars
	const { enabled } = useTranslation();

	const {
		settings: { voice, language },
	} = useSettings();

	function updateVisible() {
		if (timer.current) clearTimeout(timer.current);

		const delay = Date.now() - 10000;
		const visible = messages.filter(
			(m) => m.datetime.getTime() >= delay || m.partial === true
		);

		setList(visible);
		timer.current = setTimeout(updateVisible, 10000);
	}

	async function generateConfiguration() {
		console.log("[Translation] Generate configuration");

		if (creds.current === null) {
			console.log("[Translation] Fetching credentials");
			try {
				const { data } = await axios.get(presenceService("translator"));
				creds.current = data;
			} catch (e) {
				console.log("[Translation] CREDENTIALS FAILED", e);
			}
		}

		console.log("[Translation] Credentials fetched");
		const language = languages.find((lang) => lang.code === "es");
		const { subscription, region } = creds.current;
		// @ts-ignore: Should probably type the voice better?
		const voiceLang = language.voice[voice];
		const config = sdk.SpeechTranslationConfig.fromSubscription(
			subscription,
			region
		);

		console.log("[Translation] Configure SDK with settings", {
			voice: voiceLang,
		});

		config.addTargetLanguage(language.code);
		config.speechRecognitionLanguage = language.extendedCode;
		config.setProperty(
			sdk.PropertyId.SpeechServiceConnection_TranslationVoice,
			voiceLang
		);
		config.setProperty(
			sdk.PropertyId
				.SpeechServiceResponse_TranslationRequestStablePartialResult,
			"true"
		);

		config.setProperty(sdk.PropertyId.Speech_SegmentationStrategy, "Semantic");
		config.setProperty(sdk.PropertyId.Speech_StartEventSensitivity, "high");
		config.setProperty(
			sdk.PropertyId.SpeechServiceConnection_RecoMode,
			"Interactive"
		);

		console.log("[Translation] Configured SDK");
		setConfig(config);
	}

	useEffect(() => {
		generateConfiguration();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [voice]);

	useEffect(() => {
		updateVisible();

		return () => {
			if (timer.current) clearTimeout(timer.current);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [messages]);

	return (
		<>
			<TranslatorCompanion />
			<div id="translationCaptions">
				<ul id="translationList" className="list-unstyled">
					{list.map((item) => (
						<TranslationItem key={item.uuid} {...item} />
					))}
				</ul>
			</div>
		</>
	);
}
